module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a1Nxy"))).then(() => parcelRequire('d0iPb'));